// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__19UIS","approved":"Status_approved__3LjOn","rejected":"Status_rejected__2dSBy","expired":"Status_expired__3VPtc","label":"Status_label__18Z4c"};